import { render, staticRenderFns } from "./IconToggle.vue?vue&type=template&id=4f3746d0&"
import script from "./IconToggle.vue?vue&type=script&lang=js&"
export * from "./IconToggle.vue?vue&type=script&lang=js&"
import style0 from "./IconToggle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports